const checkUserInfo = (cookieName = 'userInfo')=>{
    // Return if called on server
    if (typeof document === 'undefined') {
        return;
    }
    try {
        const userInfoCookie = document.cookie.split('; ').find((row)=>row.startsWith(cookieName));
        if (userInfoCookie) {
            return JSON.parse(decodeURIComponent(userInfoCookie.split('=')[1]));
        }
    } catch (error) {
        console.warn('Error while accessing userInfo cookie', error);
    }
    return;
};

export { checkUserInfo as default };
